import { Loader2 } from "lucide-react";

export function PageLoader({ label = "Summoning…" }) {
  return (
    <div className="flex min-h-[50vh] items-center justify-center gap-3 text-amber-300/80" data-testid="page-loader">
      <Loader2 className="h-5 w-5 animate-spin" aria-hidden />
      <span className="font-mono text-xs uppercase tracking-[0.25em]">{label}</span>
    </div>
  );
}
